import { render, staticRenderFns } from "./letter-of-support.vue?vue&type=template&id=f3898cf6&"
import script from "./letter-of-support.vue?vue&type=script&lang=js&"
export * from "./letter-of-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports